import {fetchUtils} from 'react-admin';
import simpleRestProvider from '../misc/pdDataProvider';

const httpClient = (url, options ={}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: "application/json" });
    }

    const token = localStorage.getItem("token");
    options.headers.set("Authorization", `Token ${token}`);
    return fetchUtils.fetchJson(url, options);
}

function getHttpClient(newToken=null) {
    if (!newToken) {
        return httpClient;
    }

    return (url, options={}) => {
        if (!options.headers) {
            options.headers = new Headers({Accept: "application/json"});
        }
        options.headers.set("Authorization", `Token ${newToken}`);
        return fetchUtils.fetchJson(url, options);
    }
}

export function newDataProvider(newToken = null) {
    let apiUrl = new URL(window.config.apiRoot).pathname;
    if (process.env.NODE_ENV !== "production") {
        apiUrl = window.config.apiRoot;
    }
    const hc = getHttpClient(newToken);
    return simpleRestProvider(apiUrl, hc);
}